import { axios } from '@Root/API'

export const remove = snapshotId => {
	return axios.delete(`snapshots/${snapshotId}`)
}
